class UpdateItemCtrl {

    constructor($scope, $uibModalInstance, title, item) {

        this.$scope = $scope;
        this.$scope.title = title;
        this.$scope.item = item;
        this.$uibModalInstance = $uibModalInstance;

        console.log(title, item);

        if('undefined' != typeof this.$scope.item.pixelType) {
            this.$scope.item.pixelType = this.$scope.item.pixelType.toString();
        }

        this.$scope.ok = this.ok.bind(this);
        this.$scope.cancel = this.cancel.bind(this);

    }

    ok() {
        this.$uibModalInstance.close(this.$scope.item);
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }
}

angular.module("cpm").controller("UpdateItemCtrl", ['$scope', '$uibModalInstance', 'title', 'item', UpdateItemCtrl]);
